module.exports = __webpack_public_path__ + "static/a-xx-159-art-f3ac7bc6e489c56fbedb51285e845135.jpg";